import { compose } from 'redux';
import AnonymousPage from './anonymous-page';
import ensureLoggedIn from './ensure-logged-in';

// Use the typical `Page` middleware and redirect to `/login` when there's no token.
export default compose(ensureLoggedIn, AnonymousPage);
